/**
 * Display helpers for the "This fortnight" engagement widget. Pure so
 * `npm run test:unit` loads it under Node.
 *
 * Persona round 2026-10: the widget rendered `item.name`, but GET
 * /api/v1/engagement/upcoming sends `first_name` + `last_name` — every
 * birthday / anniversary row showed no name at all.
 */

export interface UpcomingNameParts {
  first_name?: string | null;
  last_name?: string | null;
  /** Legacy / defensive: a pre-joined name, if a server ever sends one. */
  name?: string | null;
}

/** "Meera Joshi" from first + last name; falls back to `name`, then "A colleague". */
export function upcomingDisplayName(item: UpcomingNameParts): string {
  const joined = [item.first_name, item.last_name]
    .map((p) => (p ?? "").trim())
    .filter(Boolean)
    .join(" ");
  if (joined) return joined;
  const legacy = (item.name ?? "").trim();
  return legacy || "A colleague";
}
